<div class="product-detail__features">
  <h3 i18n="product detail: details header@@product.detail.header">Details</h3>
  <ul>
    <li>
      <strong i18n="@@product.feature.pot.size">Pot size</strong>
      <span>{{ productDetail.potSize ? productDetail.potSize : 0 }}</span>
    </li>
    <li>
      <strong i18n="@@product.feature.height">Height</strong>
      <span>{{ productDetail.height ? productDetail.height : 0 }}</span>
    </li>

    @for (gradeCode of productDetail.gradeCodes; track gradeCode) {
      <li>
        <strong>{{ gradeCode.description }}</strong>
        <span>{{ gradeCode.code }}</span>
      </li>
    }

    @if (productDetail.packing) {
      <li>
        <strong i18n="@@product.feature.box.code">Box Code</strong>
        <span>{{ productDetail.packing }}</span>
      </li>
    }

    @if (productDetail.offerId) {
      <li>
        <strong i18n="@@product.feature.offer.id">Offer Id</strong>
        <span>{{ productDetail.offerId }}</span>
      </li>
    }
  </ul>
  <ul>
    @if (productDetail.barcode) {
      <li>
        <strong i18n="@@product.feature.barcode">Barcode</strong>
        <span>{{ productDetail.barcode }}</span>
      </li>
    }
    @if (productDetail.producerNumber) {
      <li>
        <strong i18n="@@product.feature.grower">Grower</strong>
        <span>{{ productDetail.producerNumber }}</span>
      </li>
    }
    @if (hasFeatures()) {
      <li>
        <strong i18n="@@product.feature.featues">Features</strong>
        <span>
          @for (feature of getFeatures(); track feature; let last = $last) {
            {{ feature }}@if (!last) {
            <br />
          }
        }
      </span>
    </li>
  }
</ul>
</div>
